<script>
import axios from 'axios';

export default class DecessosRepository {
    async getDecessos(token, page = 1, filters = []) {
        const url = `${process.env.VUE_APP_API_URL}decessos?page=${page}`;
        return axios.get(url, {
            headers: { Authorization: `Bearer ${token}` },
            params: { filters }
        });
    }

    async getDecesso(page, token, id) {
        return axios.get(`${process.env.VUE_APP_API_URL}decessos/${id}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
    }

    async createDecesso(page, data, token) {
        return axios.post(`${process.env.VUE_APP_API_URL}decessos`, data, {
            headers: { Authorization: `Bearer ${token}` }
        });
    }

    async updateDecesso(page, token, id, data) {
        return axios.put(`${process.env.VUE_APP_API_URL}decessos/${id}`, data, {
            headers: { Authorization: `Bearer ${token}` }
        });
    }

    async deleteDecesso(page, token, id) {
        return axios.delete(`${process.env.VUE_APP_API_URL}decessos/${id}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
    }

    async getAllDecessos(token) {
        return axios.get(`${process.env.VUE_APP_API_URL}decessos-all`, {
            headers: { Authorization: `Bearer ${token}` }
        });
    }
}
</script>
